import * as React from 'react';

import {ButtonGroup} from 'shells/button-group/button-group';

import {useGetSessionUser} from '../../core/use-get-session-user';

import {PhoneStatusButton} from './phone-status-button/phone-status-button';

export function SmsHeaderButtons() {
    const {user} = useGetSessionUser();
    const userCanAccessSetup = Boolean(user && user.permissions.canAccessSetup);

    return (
        <ButtonGroup>
            <PhoneStatusButton userCanAccessSetup={userCanAccessSetup} />
        </ButtonGroup>
    );
}
